import { useEffect, useRef } from 'react';

const DEFAULT_EVENTS = ['mousedown', 'touchstart'];

export function useNewClickOutside(handler, events, nodes, stopClickOutside) {
  const ref = useRef();
  useEffect(() => {
    const listener = (event) => {
      if (stopClickOutside) return;
      const { target } = event ?? {};
      const path =
        typeof event.composedPath === 'function' ? event.composedPath() : [];

      const isInsideRef =
        ref.current &&
        (ref.current.contains(target) ||
          (path.length > 0 && path.includes(ref.current)));

      if (Array.isArray(nodes)) {
        const shouldIgnore =
          target?.hasAttribute('data-ignore-outside-clicks') ||
          (!document.body.contains(target) && target.tagName !== 'HTML');

        const isInsideAny = nodes.some(
          (node) =>
            !!node &&
            (node.contains(target) || (path.length > 0 && path.includes(node))),
        );

        if (!isInsideRef && !isInsideAny && !shouldIgnore) {
          handler();
        }
      } else if (!isInsideRef) {
        handler();
      }
    };

    (events || DEFAULT_EVENTS).forEach((fn) =>
      document.addEventListener(fn, listener),
    );

    return () => {
      (events || DEFAULT_EVENTS).forEach((fn) =>
        document.removeEventListener(fn, listener),
      );
    };
  }, [ref, handler, nodes]);

  return ref;
}
